import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	ShopBagItemContainer,
	ItemContainer,
	ButtonWrapper,
	CheckoutButtonStyle,
} from './shopBagItemStyles';
import Stats from 'frontend_stats';
import FullstoryUtil from 'fullstory_util';

class CheckoutButton extends PureComponent {
	static propTypes = {
		href: PropTypes.string.isRequired,
		slug: PropTypes.string.isRequired,
	};

	onClick = e => {
		e.preventDefault();

		FullstoryUtil.sendEvent('cartItemClicked');
		const href = e.currentTarget.href;

		let followLink = () => {
			this.timeout && clearTimeout(this.timeout);
			window.location = href;
		};

		Stats.trackGeneric('shopbag-click', {
			selector: this.props.slug,
		}).then(followLink, followLink);

		this.timeout = setTimeout(followLink, 300);
	};

	render() {
		return (
			<ButtonWrapper>
				<CheckoutButtonStyle onClick={this.onClick} href={this.props.href}>
					Checkout
				</CheckoutButtonStyle>
			</ButtonWrapper>
		);
	}
}

export default CheckoutButton;
